<app-dialog-heading [heading]="'Person Overview'"></app-dialog-heading>

<div *ngIf="insuredPersonDTO">
  
  <greydom-info-panel 
    [topic]="insuredPersonDTO.status"
    [message]="getLatestCoverStatusStartAndEndDate(insuredPersonDTO.coverStatuses, insuredPersonDTO.status)"
    [messageToolTip]="'Benefit start and end date for member'"
    [iconClickable]="false"
    >
  </greydom-info-panel>

  <div class="clearfix">

    <!-------------------------------------->
    <!-- Left Section-->
    <!-------------------------------------->

    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.title?.name" [label]="'Title'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.firstName" [label]="'First Name'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.middleName" [label]="'Middle Name'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.lastName" [label]="'Last Name'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.gender?.name" [label]="'Gender'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.maritalStatus?.name"
                               [label]="'Marital Status'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.designation?.name"
                               [label]="'Designation of Person'"></app-content-field>
          </div>
        </div>


        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.status"
                               [label]="'Current Benefit Status'"></app-content-field>
          </div>
        </div>


        <div class="col-12">
          <div class="center-align">
            <app-content-field
              [content]="getStartAndEndDate(insuredPersonDTO.startDate, insuredPersonDTO.endDate)"
              [label]="'Benefit Start - End Dates for Member'"></app-content-field>
          </div>
        </div>
      </div>
    </div>

    <!-------------------------------------->
    <!-- Right Section-->
    <!-------------------------------------->

    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.cardNumber" [label]="'Card Number'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.alternative1CardNumber"
                               [label]="'Alternative Card Number'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.country?.name" [label]="'Nationality'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.nationalIdNumber"
                               [label]="'National ID Number'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.passportNumber"
                               [label]="'Passport Number'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="getBirthDateString(insuredPersonDTO.dateOfBirth)"
                               [label]="'Date Of Birth'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.association?.name"
                               [label]="'Association of Person'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="insuredPersonDTO.associatedInsuredPerson?.name"
                               [label]="'Associated Person'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="noOfConsultationVisits"
                               [label]="'Number of Consultations'"></app-content-field>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-------------------------------------->
  <!-- Variance / waiver Section-->
  <!-------------------------------------->

  <div class="flex flex-wrap content-start" style="min-height: 40px">
    <div class="col col-6 flex justify-around">
      <div style="min-width: 25vw">
        <p class="label">Waivers</p>
        <p *ngFor="let waiver of insuredPersonDTO.policyProductWaivers">
          {{waiver.productWaivers.name}}
          ({{waiver.startDate | date: dateFormat}} - {{waiver.endDate | date: dateFormat}})
        </p>
        <p *ngIf="insuredPersonDTO.policyProductWaivers == null || insuredPersonDTO.policyProductWaivers.length == 0">
          No waivers
        </p>
      </div>
    </div>
    <div class="col col-6 flex justify-around">
      <div style="min-width: 25vw">
        <p class="label">Variances</p>
        <p *ngFor="let variance of insuredPersonDTO.policyProductVariances">
          {{variance.productVariance.name}}
          ({{variance.startDate | date: dateFormat}} - {{variance.endDate | date: dateFormat}})
        </p>
        <p *ngIf="insuredPersonDTO.policyProductVariances == null || insuredPersonDTO.policyProductVariances.length == 0">
          No variances
        </p>
      </div>
    </div>
  </div>

  <!-------------------------------------->
  <!-- Exclusion/Card List Section-->
  <!-------------------------------------->

  <div class="flex flex-wrap content-start" style="min-height: 128px">
    <div class="col col-6 flex justify-around">
      <div style="min-width: 25vw">
        <p class="label">Diagnosis Exclusions</p>
        <p *ngFor="let exclusion of insuredPersonDTO.insuredPersonExclusions">
          {{exclusion.diagnosisGroup?.code}}:
          {{exclusion.diagnosis?.code}}: {{exclusion.diagnosis?.description | slice:0:25}}
          ({{exclusion.startDate | date: dateFormat}} - {{exclusion.endDate | date: dateFormat}})
        </p>
        <p *ngIf="insuredPersonDTO.insuredPersonExclusions == null || insuredPersonDTO.insuredPersonExclusions.length == 0">
          No exclusions
        </p>
      </div>
    </div>
    <div class="col col-6 flex justify-around">
      <div style="min-width: 25vw">
        <p class="label">Card History</p>
        <p *ngFor="let history of insuredPersonDTO.insuredPersonCardHistories">
          {{history.dependentCode}}: {{history.membershipNumber}}
          ({{history.startDate | date: dateFormat}} - {{history.endDate | date: dateFormat}})
        </p>
        <p *ngIf="insuredPersonDTO.insuredPersonCardHistories == null || insuredPersonDTO.insuredPersonCardHistories.length == 0">
          No card history
        </p>
      </div>
    </div>
  </div>
</div>
